import APITemplate from '@/api/APITemplate'

const url = '/api/config-component-definition'

const template = APITemplate(url)
export default {
  ...template
}
